import React from 'react';

import './Container.css';

const Container = ({ children }: { children: React.ReactNode }) => (
  <div className="Container">{children}</div>
);

export default Container;
